import { css } from 'styled-components';

export const Icon = css`
  .chakra-icon {
    width: 1em;
    height: 1em;
  }
`;
